import React, { useState } from "react";
import { Link } from "react-router-dom";
import AirAmbulanceModal from "../pages/AirAmbulance";

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <>
      {/* Top Contact Strip */}
      <div className="bg-[#3CBAC6] text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex items-center text-xs">
            <div className="flex items-center space-x-6">
              <span className="font-medium font-open-sans">Call us: +91-7827211785</span>
              <span className="font-medium font-open-sans">Email: info@medicallinkers.com</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            {/* Logo and Brand */}
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img
                  src="/images/medical-likers-logo.png"
                  alt="Medical Linkers"
                  className="h-14"
                />
              </Link>
            </div>

            {/* Navigation Menu */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/treatments" className="text-gray-700 hover:text-blue-500 transition-colors font-montserrat">
                Treatments
              </Link>
              {/* Doctors Dropdown */}
              <div className="relative group">
                <div className="flex items-center">
                  <Link to="/doctors" className="text-gray-700 hover:text-blue-500 transition-colors font-montserrat">
                Doctors
              </Link>
                  <button className="text-gray-700 hover:text-blue-500 font-bold transition-colors flex items-center ml-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </div>
                <div className="absolute top-full left-0 hidden group-hover:block bg-white shadow-lg rounded-lg py-2 min-w-[160px] z-50 border">
                  <Link to="/bestdoctorsinindia" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    India
                  </Link>
                  <Link to="/bestdoctorsinthailand" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Thailand
                  </Link>
                  <Link to="/bestdoctorsinturkey" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Turkey
                  </Link>
                  <Link to="/bestdoctorsinsouthkorea" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    South Korea
                  </Link>
                </div>
              </div>
              {/* Hospitals Dropdown */}
              <div className="relative group">
                <div className="flex items-center">
                  <Link to="/hospitals" className="text-gray-700 hover:text-blue-500 transition-colors font-montserrat">
                Hospitals
              </Link>
                  <button className="text-gray-700 hover:text-blue-500 font-bold transition-colors flex items-center ml-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                </div>
                <div className="absolute top-full left-0 hidden group-hover:block bg-white shadow-lg rounded-lg py-2 min-w-[160px] z-50 border">
                  <Link to="/BestHospitalIndia" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    India
                  </Link>
                  <Link to="/BestHospitalThailand" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Thailand
                  </Link>
                  <Link to="/BestHospitalTurkey" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Turkey
                  </Link>
                  <Link to="/BestHospitalSouthKorea" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    South Korea
                  </Link>
                </div>
              </div>
              
              {/* Country Dropdown */}
              <div className="relative group">
                <button className="text-gray-700 hover:text-blue-500 transition-colors flex items-center font-montserrat">
                  Country
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className="absolute top-full left-0 hidden group-hover:block bg-white shadow-lg rounded-lg py-2 min-w-[160px] z-50 border">
                  <Link to="/IndiaMedicalPage" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    India
                  </Link>
                  <Link to="/thailandMedicalPage" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Thailand
                  </Link>
                  <Link to="/turkeyMedicalPage" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    Turkey
                  </Link>
                  <Link to="/SouthKoreaMedicalPage" className="block px-4 py-2 text-gray-700 hover:bg-blue-500 hover:text-white font-open-sans">
                    South Korea
                  </Link>
                </div>
              </div>
              
              <Link to="/knowledgecenter" className="text-gray-700 hover:text-blue-500 transition-colors font-montserrat">
                Knowledge Center
              </Link>
              <button
                onClick={() => setIsModalOpen(true)}
                className="text-pink-500 transition-colors font-montserrat"
              >
                Air Ambulance
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-md text-gray-700 hover:text-blue-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isMobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>

            {/* Action Buttons */}
            <div className="hidden lg:flex items-center space-x-4">
              <Link
                to="/contactus"
                className="bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition-colors font-medium text-sm shadow-sm"
              >
                Get In Touch
              </Link>
              <Link
                to="/login"
                className="border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full hover:bg-blue-50 transition-colors font-medium text-sm"
              >
                Login
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="container mx-auto px-4 py-4 space-y-4">
              {/* Mobile Navigation Links */}
              <div className="space-y-4">
                <Link 
                  to="/treatments" 
                  className="block text-gray-700 hover:text-blue-500 transition-colors font-montserrat py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Treatments
                </Link>
                
                {/* Mobile Doctors Dropdown */}
                <div className="space-y-2">
                  <button
                    onClick={() => setOpenDropdown(openDropdown === 'doctors' ? null : 'doctors')}
                    className="flex items-center justify-between w-full text-gray-700 hover:text-blue-500 transition-colors font-montserrat py-2"
                  >
                    <span>Doctors</span>
                    <svg 
                      className={`w-4 h-4 transform transition-transform ${openDropdown === 'doctors' ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openDropdown === 'doctors' && (
                    <div className="pl-4 space-y-2">
                      <Link 
                        to="/bestdoctorsinindia" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        India
                      </Link>
                      <Link 
                        to="/bestdoctorsinthailand" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Thailand
                      </Link>
                      <Link 
                        to="/bestdoctorsinturkey" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Turkey
                      </Link>
                      <Link 
                        to="/bestdoctorsinsouthkorea" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        South Korea
                      </Link>
                    </div>
                  )}
                </div>

                {/* Mobile Hospitals Dropdown */}
                <div className="space-y-2">
                  <button
                    onClick={() => setOpenDropdown(openDropdown === 'hospitals' ? null : 'hospitals')}
                    className="flex items-center justify-between w-full text-gray-700 hover:text-blue-500 transition-colors font-montserrat py-2"
                  >
                    <span>Hospitals</span>
                    <svg 
                      className={`w-4 h-4 transform transition-transform ${openDropdown === 'hospitals' ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openDropdown === 'hospitals' && (
                    <div className="pl-4 space-y-2">
                      <Link 
                        to="/BestHospitalIndia" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        India
                      </Link>
                      <Link 
                        to="/BestHospitalThailand" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Thailand
                      </Link>
                      <Link 
                        to="/BestHospitalTurkey" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Turkey
                      </Link>
                      <Link 
                        to="/BestHospitalSouthKorea" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        South Korea
                      </Link>
                    </div>
                  )}
                </div>

                {/* Mobile Country Dropdown */}
                <div className="space-y-2">
                  <button
                    onClick={() => setOpenDropdown(openDropdown === 'country' ? null : 'country')}
                    className="flex items-center justify-between w-full text-gray-700 hover:text-blue-500 transition-colors font-montserrat py-2"
                  >
                    <span>Country</span>
                    <svg 
                      className={`w-4 h-4 transform transition-transform ${openDropdown === 'country' ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {openDropdown === 'country' && (
                    <div className="pl-4 space-y-2">
                      <Link 
                        to="/IndiaMedicalPage" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        India
                      </Link>
                      <Link 
                        to="/thailandMedicalPage" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Thailand
                      </Link>
                      <Link 
                        to="/turkeyMedicalPage" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Turkey
                      </Link>
                      <Link 
                        to="/SouthKoreaMedicalPage" 
                        className="block text-gray-600 hover:text-blue-500 font-open-sans py-1"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        South Korea
                      </Link>
                    </div>
                  )}
                </div>

                <Link 
                  to="/knowledgecenter" 
                  className="block text-gray-700 hover:text-blue-500 transition-colors font-montserrat py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Knowledge Center
                </Link>
                
                <button
                  onClick={() => {
                    setIsModalOpen(true);
                    setIsMobileMenuOpen(false);
                  }}
                  className="block w-full text-left text-pink-500 transition-colors font-montserrat py-2"
                >
                  Air Ambulance
                </button>
              </div>

              {/* Mobile Action Buttons */}
              <div className="space-y-3 pt-4 border-t border-gray-200">
                <Link
                  to="/contactus"
                  className="block w-full bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600 transition-colors font-medium text-sm text-center shadow-sm"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Get In Touch
                </Link>
                <Link
                  to="/login"
                  className="block w-full border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full hover:bg-blue-50 transition-colors font-medium text-sm text-center"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </Link>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Air Ambulance Modal */}
      <AirAmbulanceModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </>
  );
};

export default Header;
